/**
 * SuccessWatcher
 * Beobachtet DOM-Änderungen nach Formular-Submit
 * und führt Callback bei Erfolgsmeldungen aus.
 */
export default class SuccessWatcher {
  /**
   * @param {HTMLElement} context - Container, der überwacht wird
   * @param {Function} callback - Funktion, die bei Erfolg ausgeführt wird
   */
  constructor(context, callback) {
    this.context = context;
    this.callback = callback;
    this.delay = 3000;
  }

  /**
   * Startet die Beobachtung auf Erfolgsmeldungen.
   */
  start() {
    const observer = new MutationObserver(() => {
      const successEl = this.context.querySelector('.form-success, .message');
      if (successEl) {
        setTimeout(() => this.callback(), this.delay);
        observer.disconnect();
      }
    });
    observer.observe(this.context, { childList: true, subtree: true });
  }
}
